const config = () => ({
  timeFormat: 'mm:ss',
  timeInputFormat: 'seconds',
  dateFormat: 'YYYY-MM-DDTHH:mm:ss.sssZ',
})

export type configType = ReturnType<typeof config>
export default config
